/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ConfigurationFormMetadata } from './ConfigurationFormMetadata';
import {
    instanceOfConfigurationFormMetadata,
    ConfigurationFormMetadataFromJSON,
    ConfigurationFormMetadataFromJSONTyped,
    ConfigurationFormMetadataToJSON,
} from './ConfigurationFormMetadata';
import type { ConfigurationServiceRoleMetadata } from './ConfigurationServiceRoleMetadata';
import {
    instanceOfConfigurationServiceRoleMetadata,
    ConfigurationServiceRoleMetadataFromJSON,
    ConfigurationServiceRoleMetadataFromJSONTyped,
    ConfigurationServiceRoleMetadataToJSON,
} from './ConfigurationServiceRoleMetadata';
import type { CustomComponentMetadata } from './CustomComponentMetadata';
import {
    instanceOfCustomComponentMetadata,
    CustomComponentMetadataFromJSON,
    CustomComponentMetadataFromJSONTyped,
    CustomComponentMetadataToJSON,
} from './CustomComponentMetadata';
import type { InformationMetadata } from './InformationMetadata';
import {
    instanceOfInformationMetadata,
    InformationMetadataFromJSON,
    InformationMetadataFromJSONTyped,
    InformationMetadataToJSON,
} from './InformationMetadata';
import type { PreapprovalFormMetadata } from './PreapprovalFormMetadata';
import {
    instanceOfPreapprovalFormMetadata,
    PreapprovalFormMetadataFromJSON,
    PreapprovalFormMetadataFromJSONTyped,
    PreapprovalFormMetadataToJSON,
} from './PreapprovalFormMetadata';

/**
 * @type StepMetadata
 * 
 * @export
 */
export type StepMetadata = { stepMetadataType: 'CONFIGURATION_FORM_METADATA' } & ConfigurationFormMetadata | { stepMetadataType: 'CONFIGURATION_SERVICE_ROLE_METADATA' } & ConfigurationServiceRoleMetadata | { stepMetadataType: 'CUSTOM_COMPONENT' } & CustomComponentMetadata | { stepMetadataType: 'INFORMATION_METADATA' } & InformationMetadata | { stepMetadataType: 'PREAPPROVAL_FORM_METADATA' } & PreapprovalFormMetadata;

export function StepMetadataFromJSON(json: any): StepMetadata {
    return StepMetadataFromJSONTyped(json, false);
}

export function StepMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepMetadata {
    if (json == null) {
        return json;
    }
    switch (json['stepMetadataType']) {
        case 'CONFIGURATION_FORM_METADATA':
            return Object.assign({}, ConfigurationFormMetadataFromJSONTyped(json, true), { stepMetadataType: 'CONFIGURATION_FORM_METADATA' } as const);
        case 'CONFIGURATION_SERVICE_ROLE_METADATA':
            return Object.assign({}, ConfigurationServiceRoleMetadataFromJSONTyped(json, true), { stepMetadataType: 'CONFIGURATION_SERVICE_ROLE_METADATA' } as const);
        case 'CUSTOM_COMPONENT':
            return Object.assign({}, CustomComponentMetadataFromJSONTyped(json, true), { stepMetadataType: 'CUSTOM_COMPONENT' } as const);
        case 'INFORMATION_METADATA':
            return Object.assign({}, InformationMetadataFromJSONTyped(json, true), { stepMetadataType: 'INFORMATION_METADATA' } as const);
        case 'PREAPPROVAL_FORM_METADATA':
            return Object.assign({}, PreapprovalFormMetadataFromJSONTyped(json, true), { stepMetadataType: 'PREAPPROVAL_FORM_METADATA' } as const);
        default:
            return json;
    }
}

export function StepMetadataToJSON(json: any): any {
    return StepMetadataToJSONTyped(json, false);
}

export function StepMetadataToJSONTyped(value?: StepMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['stepMetadataType']) {
        case 'CONFIGURATION_FORM_METADATA':
            return Object.assign({}, ConfigurationFormMetadataToJSON(value), { stepMetadataType: 'CONFIGURATION_FORM_METADATA' } as const);
        case 'CONFIGURATION_SERVICE_ROLE_METADATA':
            return Object.assign({}, ConfigurationServiceRoleMetadataToJSON(value), { stepMetadataType: 'CONFIGURATION_SERVICE_ROLE_METADATA' } as const);
        case 'CUSTOM_COMPONENT':
            return Object.assign({}, CustomComponentMetadataToJSON(value), { stepMetadataType: 'CUSTOM_COMPONENT' } as const);
        case 'INFORMATION_METADATA':
            return Object.assign({}, InformationMetadataToJSON(value), { stepMetadataType: 'INFORMATION_METADATA' } as const);
        case 'PREAPPROVAL_FORM_METADATA':
            return Object.assign({}, PreapprovalFormMetadataToJSON(value), { stepMetadataType: 'PREAPPROVAL_FORM_METADATA' } as const);
        default:
            return value;
    }
}

